import { InputNumber, Modal } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import {InstitutionOptions} from "../../utils/constants";
import OptionEmailsForm from "./OptionEmailsForm";
import {useSelector} from "react-redux";
import {selectTranslate} from "../../reducers/LocaleReducer/LocalReducer";

const OptionValueModal = ({ option, title, onCancel, onOk }) => {
  const [value, setValue] = useState(null)

  useEffect(() => {
    if (option) {
      setValue(option.optionValue)
    }
  }, [option])

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      onOk(value)
    }
  }

  const renderBody = () => {
    if (option?.type === InstitutionOptions.SEND_MATCHING_HOSPITAL_EMAIL) {
      return <OptionEmailsForm
        option={option}
      />
    } else {
      return <InputNumber ref={focus} min={0} max={100} value={value} onChange={setValue} onKeyDown={handleKeyDown} />
    }
  }

  return (
    <Modal
      visible={!!option}
      title={title}
      onOk={() => onOk(value)}
      onCancel={onCancel}
      afterClose={() => setValue(null)}
      centered
      style={option?.type === InstitutionOptions.SEND_MATCHING_HOSPITAL_EMAIL ? { width: '100vw', maxHeight: '80vh' } : { maxWidth: '300px' }}
      footer={option?.type === InstitutionOptions.SEND_MATCHING_HOSPITAL_EMAIL ?? null}
    >
      {renderBody()}
    </Modal>
  )
}

export default OptionValueModal
